import { ValidationControlBase } from "@frui.ts/bootstrap";
import { bound } from "@frui.ts/helpers";
import { IBindingProps } from "@frui.ts/views";
import React from "react";
import { Col, Form } from "react-bootstrap";
import AdvancedInput from "controls/advancedInput";

export interface EmailInputProps {
  id?: string;
  translate: (code: string) => string;
  label?: string;
  disabled?: boolean;
  disableCopy?: boolean;
  disablePaste?: boolean;
  onBlur?: (e: React.FormEvent<any>) => void;
  xl?: number;
  className?: string;
}

export default class EmailInput<TTarget> extends ValidationControlBase<TTarget, EmailInputProps & IBindingProps<TTarget>> {
  @bound
  protected renderInner() {
    const { id, target, property, translate, disabled, disableCopy, disablePaste, onBlur, xl = 8, label, className } = this.props;

    return (
      <Form.Group controlId={id} as={Col} sm={12} xl={xl} className={className}>
        <Form.Label>{label || translate("email")}</Form.Label>
        <AdvancedInput
          testId={id}
          trim={true}
          target={target}
          property={property}
          placeholder={translate("emailPlaceholder")}
          disabled={disabled}
          disableCopy={disableCopy}
          disablePaste={disablePaste}
          onBlur={onBlur}
          maxLength={256}
        />
      </Form.Group>
    );
  }
}
